import { IS_MAINNET } from '@shared/utils/constant'

export const REFERRAL_CONTRACT_ADDRESS = IS_MAINNET
  ? 'inj1t4l7q6y7uzjjufxgcyr6hdugslphdqzqqt8u9x'
  : 'inj1t474vynqdjqzwzyq9clsenjqffatjqurfx95fs'
